<template>
  <div class="card" :class="{ noShadow }" :style="cardStyle" v-bind="$attrs">
    <div
      v-if="!headless"
      class="card-header d-flex justify-content-between align-items-center"
      :class="{ 'disabled-header': disabledHeader }"
    >
      <slot
        v-if="!lgTitle"
        name="title"
        class="font-weight-bold card-title-text"
      >
      </slot>
      <h5 v-else-if="title" class="card-title-text mb-0">
        {{ title }}
      </h5>
      <slot name="header" />
    </div>
    <div class="card-body">
      <slot><slot name="body"></slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noShadow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    lgTitle: Boolean,
    cardStyle: {
      type: [String, Object],
      default: ""
    },
    headless: {
      type: Boolean,
      default: false
    },
    disabledHeader: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.card.noShadow {
  box-shadow: none;
}
.card-title-text {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.card-header {
  border-radius: 25px 25px 0 0;
  padding: 0.75rem 0;
  margin: 0 1.25rem;
}

.disabled-header {
  background-color: var(--disabled-gray);
}
</style>
